module.exports = __webpack_public_path__ + "img/電気回路_6_1_4.c5e01b32.png";